import type BaseModel from "../../models/BaseModel";

/** Captures the visible successor before deletion removes rows or entire branches. */
export function prepareC1NavigatorDeletion(object: BaseModel): (() => void) | undefined {
  const navigator = document.activeElement?.closest(".C1_navigator");
  if (!navigator) return;
  const rows = Array.from(navigator.querySelectorAll<HTMLElement>(".dataline"))
    .filter(row => !row.closest('[hidden], [aria-hidden="true"]'));
  const entries = rows.map(row => ({row, object: state.objectRegistry.getObject<BaseModel>(row.dataset.connectionObjectId ?? "")}));
  const focused = document.activeElement?.closest(".dataline");
  const index = entries.findIndex(entry => entry.row === focused && entry.object === object);
  if (index < 0) return;
  const candidates = [...entries.slice(index + 1), ...entries.slice(0, index).reverse()];
  return () => {
    if (!object.isDeleted) return;
    for (const candidate of candidates) {
      if (!candidate.object?.treeViewModel.isSelectable) continue;
      let ancestor: BaseModel | undefined = candidate.object;
      while (ancestor && !ancestor.isDeleted) ancestor = ancestor.parent as BaseModel | undefined;
      if (ancestor) continue;
      const row = document.getElementById(candidate.row.id);
      if (!row || !navigator.contains(row)) continue;
      // Row focus uses the regular C1 selection action, including its delayed dock update.
      row.focus();
      return;
    }
  };
}
